//@flow
import React from 'react';

import ArrowLeft from 'dibs-icons/exports/ArrowLeft';
import ArrowRight from 'dibs-icons/exports/ArrowRight';

import styles from './PhotoArrowOverlay.scss';
import type { ProjectPhoto } from '../InteriorPhotoWrapper';

type PhotoArrowOverlayProps = {
    photos: Array<?ProjectPhoto>,
    pageChange: string => void,
    photoCount: number,
    photoIndex: number,
};

function getHandler(
    nextPath: ?string,
    pageChange: string => void
): (SyntheticEvent<any>) => boolean {
    return (event: SyntheticEvent<any>) => {
        event.preventDefault();
        if (nextPath) {
            pageChange(nextPath);
        }
        return false;
    };
}

const LeftArrow = (props: PhotoArrowOverlayProps) => {
    const { photoIndex, photoCount, pageChange, photos } = props || {};
    const { url } = photos[photoIndex - 1] || photos[photoCount - 1] || {};

    return (
        <a className={styles.leftArrowBox} onClick={getHandler(url, pageChange)} href={url}>
            <ArrowLeft className={styles.arrow} />
        </a>
    );
};

const RightArrow = (props: PhotoArrowOverlayProps) => {
    const { photoIndex, photos, pageChange } = props || {};
    const { url } = photos[photoIndex + 1] || photos[0] || {};

    return (
        <a className={styles.rightArrowBox} onClick={getHandler(url, pageChange)} href={url}>
            <ArrowRight className={styles.arrow} />
        </a>
    );
};

export const PhotoArrowOverlay = (props: PhotoArrowOverlayProps) => (
    <div className={styles.wrapper}>
        <LeftArrow {...props} />
        <RightArrow {...props} />
    </div>
);

export default PhotoArrowOverlay;
